import { useState } from "react";
import { Search } from "lucide-react";

const CONFS = [["Eastern Conference", "East"], ["Western Conference", "West"]];

export function TeamPicker({ teams, selected, onPick }) {
  const [q, setQ] = useState("");
  const match = (t) => !q || `${t.name} ${t.code}`.toLowerCase().includes(q.toLowerCase());
  return (
    <aside className="tm-side" data-testid="teams-picker">
      <h2>Teams</h2>
      <label className="tm-select">
        <span>Team</span>
        <select value={selected || ""} onChange={(e) => onPick(e.target.value)} data-testid="teams-select">
          {CONFS.map(([conf, short]) => {
            const list = teams.filter((t) => (t.conference || "") === conf).sort((a, b) => (a.seed || 99) - (b.seed || 99));
            return list.length > 0 && (
              <optgroup key={conf} label={short}>
                {list.map((t) => <option key={t.id} value={t.id}>{t.name} ({t.wins ?? 0}-{t.losses ?? 0})</option>)}
              </optgroup>
            );
          })}
          {!teams.some((t) => t.conference) && teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </label>
      <label className="tm-search"><Search size={14} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search team" data-testid="teams-search" />
      </label>
      {CONFS.map(([conf, short]) => {
        const list = teams.filter((t) => (t.conference || "") === conf && match(t)).sort((a, b) => (a.seed || 99) - (b.seed || 99));
        if (!list.length) return null;
        return (
          <div key={conf} className="tm-conf">
            <span className="tm-conf-label">{short}</span>
            {list.map((t) => (
              <button key={t.id} type="button" className={`tm-team ${t.id === selected ? "is-active" : ""}`} onClick={() => onPick(t.id)} data-testid={`teams-pick-${t.code}`}>
                <img src={t.logo} alt="" loading="lazy" />
                <span>{t.short_name || t.name}</span>
                <em>{t.wins ?? 0}-{t.losses ?? 0}</em>
              </button>
            ))}
          </div>
        );
      })}
      {!teams.some((t) => t.conference) && teams.filter(match).map((t) => (
        <button key={t.id} type="button" className={`tm-team ${t.id === selected ? "is-active" : ""}`} onClick={() => onPick(t.id)} data-testid={`teams-pick-${t.code}`}>
          <img src={t.logo} alt="" loading="lazy" /><span>{t.short_name || t.name}</span>
        </button>
      ))}
    </aside>
  );
}
